import BaseTable from 'components/Tables/BaseTable';
import { sortBy } from 'lodash';
import FlowListDetailPanel from 'pages/ScenarioExposure/Flow/ScenariosManagement/PROCTrabalhadores/FlowStepListDetailPanel';
import React, { useRef } from 'react';
import { connect } from 'react-redux';
import theme from 'source/theme';
import tableIcons from 'utils/icons/materialTableIcons';
import columns from 'utils/tables/columns/scenarioExposure/flow/flowPcSuScenarioDescriptorExposure';

const Component = props => {
  const {
    descriptorId, descriptorsById, scenariosById, stepsById, flowScenarioDescriptors,
    flowsById, TABLE_HEIGHT
  } = props;

  const { setDescriptorId } = props;
  const tableRef = useRef();

  const mergedProductDescriptors = [];
  const descriptorRepetitions = [];

  /**
   * Received Filtered ScenarioDescriptors that make sense according to DESCRIPTOR and STEPS found above.
   * Adding information of Flow and Steps to each DESCRIPTOR below
   */
  flowScenarioDescriptors.forEach(fSD => {
    if (!descriptorRepetitions.includes(fSD.descriptor_id)) {
      const scenariodescriptorGrouped = flowScenarioDescriptors.filter(item =>
        item.descriptor_id === fSD.descriptor_id
      );
      const mergedDescriptor = {
        id: fSD.descriptor_id,
        descriptor_code: descriptorsById[fSD.descriptor_id].code,
        descriptor_description: descriptorsById[fSD.descriptor_id].description,
        flowsInfo: [],
        stepsInfo: {}
      };

      const repeatedFlows = [];
      scenariodescriptorGrouped.forEach(sdg => {
        const flow = flowsById[scenariosById[sdg.scenario_id].flow_id];
        if (!repeatedFlows.includes(flow.id)) {
          mergedDescriptor.flowsInfo.push({
            flow_id: flow.id,
            flow_code: flow.code,
            flow_name: flow.name
          });
          repeatedFlows.push(flow.id);
          mergedDescriptor.stepsInfo[flow.id] = [{
            step_id: sdg.step_id,
            step_code: stepsById[sdg.step_id].name,
            step_name: stepsById[sdg.step_id].master_step_id ?
              stepsById[stepsById[sdg.step_id].master_step_id].description + ' / ' + stepsById[sdg.step_id].description :
              stepsById[sdg.step_id].description
          }];
        } else {
          mergedDescriptor.stepsInfo[flow.id].push({
            step_id: sdg.step_id,
            step_code: stepsById[sdg.step_id].name,
            step_name: stepsById[sdg.step_id].master_step_id ?
              stepsById[stepsById[sdg.step_id].master_step_id].description + ' / ' + stepsById[sdg.step_id].description :
              stepsById[sdg.step_id].description
          });
        }
      });

      descriptorRepetitions.push(fSD.descriptor_id);
      mergedProductDescriptors.push(mergedDescriptor);
    }
  });

  const rows = sortBy(mergedProductDescriptors, ['id']);

  return (
    <React.Fragment>
      <BaseTable
        ref={tableRef}
        title={'DESCRITORES DO FLUXO'}
        columns={columns}
        data={rows}
        order={false}
        paging={false}
        onRowClick={() => null}
        onRowDoubleClick={setDescriptorId ? rowData => setDescriptorId(rowData.id) : null}
        options={{
          // toolbar: false,
          // search: false,
          maxBodyHeight: TABLE_HEIGHT,
          minBodyHeight: TABLE_HEIGHT,
          rowStyle: setDescriptorId ? rowData => ({
              backgroundColor: (rowData.id === descriptorId) ?
                theme.palette.primary.light :
                theme.palette.background.veryLight
            }) :
            ({ backgroundColor: theme.palette.background.veryLight })
        }}
        detailPanel={[
          () => ({
            icon: tableIcons.Flow,
            tooltip: 'Fluxogramas',
            render: ({ rowData }) => <FlowListDetailPanel row={rowData}/>
          })
        ]}
      />
    </React.Fragment>
  );
};


const mapStateToProps = (state) => ({
  descriptorsById: state.descriptors.models,
  scenariosById: state.scenarios.models,
  flowsById: state.flows.models,
  stepsById: state.steps.models
});

export default connect(mapStateToProps)(Component);
